export default "__VITE_ASSET__iPs5KB5f__"